import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/evaluators'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'evaluators'

export const metadata = {
  icon: 'align-justify',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const EvaluatorsListPage = createListPage({ metadata, api, actionCreators, Content })
const EvaluatorsDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { EvaluatorsListPage, EvaluatorsDetailPage }
